module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Wysgpc/tc-custom/9781526718426.jpg?1699985045072",
      "alt": "This image is the cover for the book Battle of Fontenoy 1745"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Battle of Fontenoy 1745\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A detailed history of a pivotal, bloody battle in a clash of European dynasties, with illustrations included.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The Battle of Fontenoy marked a turning point in the War of the Austrian Succession, yet it has rarely been analyzed in depth and the Europe-wide conflict in which it played a part is little understood. James Falkner, in this perceptive and original account, puts the record straight by describing the fighting in graphic detail and setting it in the context of the sequence of wars that determined the shape of Europe during the eighteenth century."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Great Britain, with her Austrian and Dutch allies, fought to ensure that Maria Theresa of Austria should be able to take the throne of the Holy Roman Empire. Ranged against her interests was the might of Louis XV's France, which strove to weaken Austria by promoting a Bavarian aspirant to the Imperial throne. On May 11, 1745 at Fontenoy in the Austrian Netherlands, the two sides met in a ferocious daylong struggle that changed the course of the war. James Falkner’s narrative gives a fascinating insight into the Battle of Fontenoy itself and more widely into the nature of warfare in Europe more than 250 years ago.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      James Falkner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword/Pen and Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0